import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CircleBranding } from 'src/api/circles';

/**
 * Branding of a circle shown on a public page outside /circle/:id (the OTH
 * registration page), so the app's top bar can match that page. The page sets
 * it once it has loaded the circle's public data and clears it when it closes.
 */
interface PublicBrandingState {
  circleId: string | null;
  branding: CircleBranding | null;
}

const initialState: PublicBrandingState = { circleId: null, branding: null };

const publicBrandingSlice = createSlice({
  name: 'publicBranding',
  initialState,
  reducers: {
    setPublicBranding: (
      state,
      action: PayloadAction<{
        circleId: string;
        branding: CircleBranding | null;
      }>
    ) => {
      state.circleId = action.payload.circleId;
      state.branding = action.payload.branding;
    },
    clearPublicBranding: () => initialState,
  },
});

export const { setPublicBranding, clearPublicBranding } =
  publicBrandingSlice.actions;
export default publicBrandingSlice.reducer;
